/**
 * Sprint 165 — Si el servidor dice que la misma carga ya entró hace un momento, se pregunta una vez.
 * Sí → se reintenta confirmándolo (con la misma clave: la primera no la gastó). No → no se carga nada.
 */
export async function conConfirmacionDeCarga<R extends { ok: boolean; error?: string; codigo?: string }>(
  enviar: (confirmada: boolean) => Promise<R>,
): Promise<R> {
  const r = await enviar(false);
  if (r.ok || r.codigo !== 'CARGA_REPETIDA') return r;
  const otra = window.confirm(`${r.error}\n\nAceptar = sí, es otra carga.\nCancelar = no, ya estaba cargada.`);
  return otra ? enviar(true) : r;
}
